import React from "react";
import { Heart, Sparkles, Leaf } from "lucide-react";
const LOGO = "https://customer-assets.emergentagent.com/job_brigadeiro-shop-10/artifacts/ro8wmkw2_Logo%20Confeitaria%20Divertido%20Rosa%20e%20Bege.png";

export default function AboutPage() {
  return (
    <div data-testid="about-page" className="max-w-5xl mx-auto px-6 sm:px-8 py-20">
      <div className="text-center">
        <img src={LOGO} alt="Caseirinhos" className="w-24 h-24 rounded-full mx-auto shadow-lg" />
        <p className="text-xs uppercase tracking-widest text-rose-accent mt-6">Sobre nós</p>
        <h1 className="font-heading text-5xl sm:text-6xl text-cocoa-dark mt-3">
          A doçaria nasce em casa
          <span className="block font-accent text-rose-accent text-4xl mt-2">e chega até si</span>
        </h1>
        <p className="text-cocoa-soft text-lg mt-8 leading-relaxed max-w-2xl mx-auto">
          Os Caseirinhos começaram numa cozinha pequena, com receitas passadas por gerações.
          Hoje continuamos a fazer cada salgado e cada brigadeiro à mão, em lotes pequenos,
          para que cada bocado mantenha o sabor da família.
        </p>
      </div>

      <div className="mt-16 grid md:grid-cols-3 gap-10">
        <Value icon={Heart} title="Feito com amor" desc="Cada peça é moldada à mão. Não há atalhos. Há tempo e carinho." />
        <Value icon={Leaf} title="Ingredientes simples" desc="Privilegiamos ingredientes frescos e produtores locais sempre que possível." />
        <Value icon={Sparkles} title="Sempre fresco" desc="Preparamos sob encomenda, para que tudo chegue impecável à sua mesa." />
      </div>
    </div>
  );
}

function Value({ icon: Icon, title, desc }) {
  return (
    <div className="bg-cream-deep rounded-2xl p-8 text-center border border-cocoa/10">
      <div className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-rose/30 text-cocoa-dark mb-4">
        <Icon className="w-5 h-5" />
      </div>
      <h3 className="font-heading text-2xl text-cocoa-dark">{title}</h3>
      <p className="text-cocoa-soft mt-2 text-sm leading-relaxed">{desc}</p>
    </div>
  );
}
